import { render } from "./App.vue?vue&type=template&id=2afd9bee"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2afd9bee&lang=css"

import exportComponent from "/home/ic/Project/webb/lunch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__